var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEncryptionInbound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.4C9.7 12.6 9.2 12.7 8.8 12.7V14H10.7V15H8.8H4.8C4.1 15 3.5 14.4 3.5 13.7V7C3.5 6.3 4.1 5.7 4.8 5.6H5.5V4.3C5.5 2.5 7 1 8.8 1C9.3 1 9.7 1.1 10 1.4L9.5 2.5C9.3 2.4 9 2.3 8.8 2.3C7.7 2.3 6.8 3.2 6.8 4.3V5.7H7.2H7.6H8.6H10.6V6.7H8.8V8C9.3 8 9.7 8.1 10 8.4L9.5 9.2C9.3 9.1 9.1 9 8.8 9C8.1 9 7.5 9.5 7.5 10.3C7.5 11.1 8.1 11.7 8.8 11.7C9.1 11.7 9.3 11.6 9.5 11.5L10 12.4ZM10.2 10.3C10.2 10.1 10.1 9.90001 10 9.70001L10.9 9.20001C11.1 9.50001 11.2 9.90001 11.2 10.3C11.2 10.7 11.1 11.1 10.9 11.4L10 10.9C10.1 10.7 10.2 10.5 10.2 10.3ZM11.7 4.60001H10.5V5.60001H11.6001V6.60001H12.3001C12.6001 6.60001 12.8001 6.80001 12.9001 7.00001L13.8001 6.50001C13.5001 6.00001 12.9001 5.60001 12.3001 5.60001H11.7V4.60001ZM11.7 3.69999L10.5 3.79999C10.5 3.39999 10.3 2.99999 10 2.79999L10.9 1.79999C11.4 2.29999 11.7 2.99999 11.7 3.69999ZM13 7.79999H14V9.79999H13V7.79999ZM12.3 14H11.7V15H12.3C13 15 13.6 14.6 13.9 13.9L13 13.5C12.9 13.8 12.6 14 12.3 14ZM13 10.8H14V12.8H13V10.8Z",
    fill: "#AFAFAE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEncryptionInbound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_encryption_inbound.8d78f1cf9a6d5c143bee44d429ac9169.svg";